import { Platform } from 'react-native';

function checkEmbedded() {
  if (Platform.OS !== 'web') {
    return false;
  }
  if (
    window.location.search.includes('embedded') ||
    window.self !== window.top
  ) {
    return true;
  }

  return false;
}

const embedded = checkEmbedded();

export const isEmbedded = embedded;
